import { getAuth, onAuthStateChanged } from "firebase/auth";
import { app } from "../../app/config/firebase";
import { onSnapshot } from "@firebase/firestore";
import { SIGN_IN_USER, SIGN_OUT_USER } from "./authConstants";
import { appLoaded, asyncActionFinish } from "../../app/async/asyncReducer";
import {
  dataFromSnapshot,
  listenToDocFromFirestore,
} from "../../app/firestore/firestoreService";
import { listenToCurrentUserAccount } from "../account/accountActions";
import { closeModal } from "../../app/common/modals/modalReducer";
import { FIRESTORE_USERS_COLLECTION } from "../../app/firestore/firestoreConstants";

const auth = getAuth(app);

export function signInUser(user) {
  return {
    type: SIGN_IN_USER,
    payload: user,
  };
}

export function verifyAuth() {
  return function (dispatch) {
    return onAuthStateChanged(auth, (user) => {
      if (user) {
        dispatch(signInUser(user));
        const accountRef = listenToDocFromFirestore({
          dbCollection: FIRESTORE_USERS_COLLECTION,
          id: user.uid,
        });
        onSnapshot(accountRef, (snapshot) =>
          dispatch(
            listenToCurrentUserAccount({
              dateLastSignedInAuth: new Date(),
              isEmailVerified: user.emailVerified,
              ...dataFromSnapshot(snapshot),
            })
          )
        );
        dispatch(appLoaded());
        dispatch(asyncActionFinish());
      } else {
        dispatch(closeModal());
        dispatch(signOutUser());
        dispatch(appLoaded());
      }
    });
  };
}

export function signOutUser() {
  return {
    type: SIGN_OUT_USER,
  };
}
